import { render, staticRenderFns } from "./MultiCoreData.vue?vue&type=template&id=8d18cb58&scoped=true"
import script from "./MultiCoreData.vue?vue&type=script&lang=ts"
export * from "./MultiCoreData.vue?vue&type=script&lang=ts"
import style0 from "./card.less?vue&type=style&index=0&id=8d18cb58&prod&lang=less&scoped=true&external"
import style1 from "./MultiCoreData.vue?vue&type=style&index=1&id=8d18cb58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d18cb58",
  null
  
)

export default component.exports